var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.294,
    height: 29,
    viewBox: "0 0 23.294 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28570",
    "data-name": "Group 28570",
    transform: "translate(-29 -378)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Location_4336344",
    transform: "translate(29 378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16777",
    "data-name": "Path 16777",
    d: "M29.517,10A11.658,11.658,0,0,0,17.87,21.647c0,5.532,6,12.184,11.042,16.787l.605.565.605-.584c5.593-5.365,11.042-11.082,11.042-16.769A11.658,11.658,0,0,0,29.517,10Zm0,26.539c-6.365-5.93-9.856-11.2-9.856-14.891a9.855,9.855,0,1,1,19.711,0C39.374,26.439,34.592,31.616,29.517,36.539Z",
    transform: "translate(-17.87 -10)",
    fill: "#EB1700"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16778",
    "data-name": "Path 16778",
    d: "M42.121,29.77a4.481,4.481,0,1,0,4.48,4.48A4.481,4.481,0,0,0,42.121,29.77Zm0,7.167a2.686,2.686,0,1,1,2.686-2.686A2.686,2.686,0,0,1,42.121,36.937Z",
    transform: "translate(-30.473 -22.603)",
    fill: "#EB1700"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_15640",
    "data-name": "Ellipse 15640",
    cx: 3.5,
    cy: 3.5,
    r: 3.5,
    transform: "translate(37 386)",
    fill: "#EB1700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0bf843f11da36efd28b7a487728785a1.svg";
export { ForwardRef as ReactComponent };